app.controller("StudentNewNotificationWindowController", [
    "$scope", "$q", "item", "$uibModalInstance",
    function ($scope, $q, item, $uibModalInstance) {
        $scope.item = item;
        $scope.notification = item.notification;

        $scope.getTime = function (item) {
            var now = new Date;
            var sendDate = new Date(item.createDate);
            var pastHours = Math.round( (now.getTime()-sendDate.getTime())/(60*60*1000) );
            var pastMinutes = Math.round( (now.getTime()-sendDate.getTime())/(60*1000) );

            if(pastHours < 1) return pastMinutes + " წუთის წინ";
            else if(1< pastHours && pastHours < 24) return pastHours + " საათის წინ";
            else return item.notification.createDateString;
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);